export const routes = [
    {
        name: 'index',
        path: ['/', '/index.html'],
        page: 'example'
    },
    {
        name: 'dobleMalta',
        path: ['/cervezas-club-colombia/club-doble-malta', '/como-servir-la-cerveza'],
        page: 'dobleMalta'
    },
    {
        name: 'game',
        path: ['/cervezas-club-colombia/club-doble-malta/juega-y-gana', '/como-servir-la-cerveza/juego'],
        page: 'game'
    },
    {
        name: 'ranking',
        path: ['/cervezas-club-colombia/club-doble-malta/ranking', '/cervezas-club-colombia/club-colombia-doble-malta/juega-y-gana/ranking'],
        page: 'ranking'
    }
]